export function replaceAll(str: string, search: string, replacement: string): string {
  return str.replace(new RegExp(search.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), replacement);
}

export function formatMessageWithPlaceholders(
  message: string,
  replacements: { [key: string]: string }
): string {
  let formattedMessage = message;
  for (const placeholder in replacements) {
    formattedMessage = replaceAll(formattedMessage, placeholder, replacements[placeholder]);
  }
  return formattedMessage;
}

const RnPlatformCompanyName = "Medflyt at Home - RN on Demand";

export const RnPlatformEmailPlaceHolders = {
  patientName: "PATIENT_NAME",
  outsourcedAgencyName: "OUTSOURCED_AGENCY_NAME",
  agencyMemberName: "AGENCY_MEMBER_NAME",
};

export const RnPlatformEmails = {
  sendPatientDocuments: {
    subject: `Requested Documents for ${RnPlatformEmailPlaceHolders.patientName}`,
    content: `
        Dear ${RnPlatformEmailPlaceHolders.outsourcedAgencyName} Team,<br/>
        Please find the requested documents for ${RnPlatformEmailPlaceHolders.patientName} attached to this email.<br/><br/>
        If any edits or updates are needed, kindly respond directly to this email.<br/>
        Thank you, and I look forward to hearing from you.<br/><br/><br/>
        Best regards,<br/>
        ${RnPlatformEmailPlaceHolders.agencyMemberName}<br/>
        ${RnPlatformCompanyName}
       `,
  },
};

export const RnPlatformEmailFooters = {
  confidentialityNotice: `
    <br/><br/>
    ===========
    <br/>
    Confidentiality Notice: This e-mail message, including any attachments, is for the sole use of the intended recipient(s) and may contain confidential and privileged information. Any unauthorized review, use, disclosure or distribution is prohibited. If you are not the intended recipient, please contact the sender by reply e-mail and destroy all copies of the original message. This communication may contain Confidential Protected Health Information. This information is intended only for the exclusive use of the addressee. The authorized recipient of this information is prohibited from disclosing this information to any other party unless required to do so by law or regulation and is required to destroy the information after its stated need has been fulfilled. If you are not the intended recipient, you are hereby notified that any disclosure, copying, distribution or action taken in reliance on the contents of these documents is strictly prohibited by Federal law. If you have received this information in error, please notify the sender immediately and destroy all forms of this communication (electronic or paper).
    `,
};
